module.exports = __webpack_public_path__ + "static/media/ic-excluir.18b83cab.svg";